import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useQuery, useQueries, useQueryClient } from 'react-query';

import { t } from '../../utils/i18n';
import { LOGO_ORIENTATION, BEAMER_ID, SEVERITY, NOOP } from '../../constants';
import { ErrorBoundary } from '../ErrorBoundary';
import MicroApp from '../MicroApp';
import IconButton from '../IconButton';
import Button from '../Button';
import SearchWrapper from '../SearchWrapper';
import SMSInfoMessage from '../SMSInfoMessage';
import Notifications from '../../containers/Notifications';
import Tracer from '../../utils/tracer';
import EVENTS from '../../constants/event-bus-events';
import createQueryConfig from '../../queries';
import Logger from '../../utils/logger';

const getLogoDimensions = () => {
  switch (LOGO_ORIENTATION) {
    case 'LANDSCAPE':
      return { width: 'auto', height: '24px' };
    case 'SQUARE':
    default:
      return { width: '42px', height: '42px' };
  }
};

function Header({
  logoUrl,
  onSearchActivation,
  onClickButton,
  onClickSMSClose,
  merchant,
  account,
  onClickLogout,
  company,
  uiVisibility,
  severity,
  isAdmin,
  whiteLabelSchemaless,
  locale,
  settings,
  onAction,
  apiClient,
  eventBus,
  trackMethod,
}) {
  const onButtonClick = useCallback((event) => {
    onClickButton('menu', event);
    Tracer.addAction('menu_clicked');
  }, []);

  const handleClickButton = (name) => (event) => {
    onClickButton(name, event);
  };

  const getHelpCenterLink = ({ config, tmpLocale, companyName }) => {
    switch (companyName) {
      case 'shore':
        return config && config.helpcenter && config.helpcenter.home
          ? config.helpcenter.home.replace(
              '__locale__',
              tmpLocale.toLowerCase()
            )
          : '';

      case 'localsearch':
        return 'https://cc.localsearch.ch/s/help?language=de&topic=Product_related_questions_NV&subtopic=MyCOCKPIT_booking_system_NV';
      default:
        return null;
    }
  };

  const smsDisplayInfo = (clickEvent, severityType, isAdmin) => {
    switch (severityType) {
      case SEVERITY.DANGER:
        return (
          <SMSInfoMessage
            onCloseClicked={clickEvent}
            isHiddenSm
            status={SEVERITY.DANGER}
            isAdmin={isAdmin}
          />
        );

      case SEVERITY.WARNING:
        return (
          <SMSInfoMessage
            onCloseClicked={clickEvent}
            isHiddenSm
            status={SEVERITY.WARNING}
            isAdmin={isAdmin}
          />
        );
      case SEVERITY.NONE:
        return null;

      default:
        return null;
    }
  };

  return (
    <header className="as-Header">
      <div className="as-Header-top">
        <Button
          data-testid="shore-home-button"
          title={t('button.calendar.title')}
          href="/calendar"
          className="as-Header-logoButton"
          onClick={handleClickButton('calendar')}
        >
          {logoUrl && (
            <img
              alt="Logo"
              style={getLogoDimensions()}
              src={logoUrl}
              className="as-Header-logo"
            />
          )}
        </Button>
        <div className="as-Header-searchBox">
          <SearchWrapper
            onActivate={onSearchActivation}
            title={t('button.search.title')}
            placeholder={t('button.search.placeholder')}
          />
        </div>
        {smsDisplayInfo(onClickSMSClose, severity, isAdmin)}
        <Notifications
          isWhitelabelShore={company === 'shore'}
          trackMethod={trackMethod}
          shouldShowProductNotification={Boolean(BEAMER_ID)}
        />
      </div>
    </header>
  );
}

export default Header;
